import { FormCheck, Table } from "react-bootstrap";
import styled from "styled-components";

const StyledLabel = styled.p`
    font-size: 13px;
    line-height: 120%;
    color: #787878;
    margin: 0 32px 0 0;
`;

const StyledFormCheck = styled(FormCheck)`
    .form-check-input {
        width: 17px;
        height: 17px;
        border: 1px solid #9654ff;
        border-radius: 2px;
        &:checked {
            background-color: #9654ff;
        }
    }
`;

const StyledTitle = styled.p`
    font-size: 17px;
    line-height: 150%;
    margin: 0 16px 0 0;
    color: #404040;
`;

const StyledPaginationContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    border-width: 0px 1px 1px;
    border-color: rgb(228, 228, 228);
    border-style: solid;
    padding-right: 5px;
`;

const StyledTableAssociation = styled(Table)`
    margin-bottom: 0 !important;
    th {
        vertical-align: middle;
        justify-content: initial;
        align-items: center;
        padding: 12px 12px;
        gap: 8px;
        left: 108px;
        top: 337px;
        background: #e4e4e4;
    }
    td {
        justify-content: initial;
        vertical-align: middle;
        align-items: center;
        background: #ffffff;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #e4e4e4;
        font-size: 15px;
        color: #404040;
        font-weight: 400;
        font-size: 17px;
        line-height: 150%;
        padding: 12px 12px;
        text-align: left;
        border-style: solid;
    }
`;
const StyledContainerActions = styled.div`
    @media (max-width: 990px) {
        display: flex;
        align-items: center;
        gap: 26px;
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
        flex-direction: inherit;
        justify-content: center;
    }
    @media (min-width: 991px) {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 26px;
    }
`;

const StyledNotFound = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 56px;
    border-width: 0px 1px 1px;
    border-color: rgb(228, 228, 228);
    border-style: solid;
    padding-left: 16px;
`;

export {
    StyledLabel,
    StyledFormCheck,
    StyledTitle,
    StyledPaginationContainer,
    StyledTableAssociation,
    StyledContainerActions,
    StyledNotFound,
};
